import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getHasRoute } from '../../../../data/booking/selectors/booking';
import ChooseRouteContainer from '../../../booking/containers/ChooseRouteContainer';
import FirstStepFormContainer from '../../../booking/containers/bag_transport/FirstStepFormContainer';

class AddBagTransportContainer extends Component {
    static propTypes = {
        hasRoute: PropTypes.bool
    };

    render() {
        const { hasRoute } = this.props;

        if (!hasRoute) {
            return <ChooseRouteContainer />;
        }

        return <FirstStepFormContainer />;
    }
}

export default connect(
    state => ({
        hasRoute: getHasRoute(state.booking)
    }),
    null
)(AddBagTransportContainer);
